module.exports = __webpack_public_path__ + "static/media/2-3.6cbf19d9.webp";